import React, { PureComponent } from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import styled from 'styled-components';

import Heading from '../heading';
import jaLocale from './ja.locale.js';

const textLengths = {
  '1': 11,
  '2': 11,
  '3': 12,
  '6': 11
};

/**
 * Container element
 */
const Container = styled.div`
  padding: 0.5em 2.5em;
  align-self: stretch;
  line-height: 1.5;
`;

/**
 * Disclaimer
 */
class Disclaimer extends PureComponent {
  constructor(props) {
    super(props);
    this.props.addTranslationForLanguage(jaLocale, 'ja');
  }

  render() {
    const { pageContext } = this.props;
    const gameId = pageContext.gameId;
    return (
      <Container>
        <Heading>
          <Translate id="disclaimer.heading" />
        </Heading>
        {[...Array(textLengths[gameId]).keys()].map(index => (
          <p key={index}>
            <Translate
              id={`disclaimer.games.${gameId}.text.${index}`}
              options={{ renderInnerHtml: true }}
            />
          </p>
        ))}
      </Container>
    );
  }
}

export default withLocalize(Disclaimer);
